var config = {
    api_url: "api.editor.john-steel.com:3030",
    // en dev :
    //api_url: "localhost:3030",
    editor_url: "editor.john-steel.com:443"
};
module.exports = config;
var config = {
    api_url: "api.editor.steellab.fr:3030",
    editor_url: "editor.steellab.fr:443"
};
module.exports = config;
var config = {
    api_url: "api.editor.steellab.fr:3030",
    editor_url: "editor.steellab.fr:443"
};
module.exports = config;
var config = {
    api_url: "api.editor.steellab.fr:3030",
    editor_url: "editor.steellab.fr:443"
};
module.exports = config;
